<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-layout row class="align-center layout px-4 pt-4 app--page-header">
          <div class="page-header-left">
            <h3 class="pr-3">Historical List User</h3>
          </div>
          <v-spacer></v-spacer>
        </v-layout>
        <v-flex lg2>
          <label>Login Type </label>
          <v-select
            :items="loginSession"
            v-model="e1"
            label="Select"
            item-text="type"
            item-value="in"
            single-line
            @change="type(e1)"
          ></v-select>
        </v-flex>
        <v-flex lg3>
          <label>From</label>
          <v-menu
            class="pr-2"
            ref="statDate"
            lazy
            :close-on-content-click="false"
            v-model="startDateMenu"
            transition="scale-transition"
            offset-y
            full-width
            :nudge-bottom="-22"
            max-width="290px"
            :return-value.sync="startDate"
          >
            <v-text-field
              slot="activator"
              v-model="startDate"
              append-icon="event"
              readonly
            ></v-text-field>
            <v-date-picker v-model="startDate" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="startDateMenu = false"
                >Cancel</v-btn
              >
              <v-btn
                flat
                color="primary"
                @click="$refs.statDate.save(startDate)"
                >OK</v-btn
              >
            </v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex lg3>
          <label>To</label>
          <v-menu
            ref="endDate"
            lazy
            class="pr-2"
            :close-on-content-click="false"
            v-model="endDateMenu"
            transition="scale-transition"
            offset-y
            full-width
            :nudge-bottom="-22"
            min-width="290px"
            :return-value.sync="endDate"
          >
            <v-text-field
              slot="activator"
              v-model="endDate"
              append-icon="event"
              readonly
            ></v-text-field>
            <v-date-picker v-model="endDate" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="endDateMenu = false"
                >Cancel</v-btn
              >
              <v-btn flat color="primary" @click="$refs.endDate.save(endDate)"
                >OK</v-btn
              >
            </v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-text-field
                flat
                solo
                prepend-icon="search"
                placeholder="Type something"
                v-model="search"
                hide-details
                class="hidden-sm-and-down"
              ></v-text-field>
              <v-btn icon>
                <v-icon>filter_list</v-icon>
              </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="complex.headers"
                :search="search"
                :items="complex.items"
                :rows-per-page-items="[10, 25, 50, { text: 'All', value: -1 }]"
                class="elevation-1"
                item-key="name"
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.first_name }}</td>
                  <td>{{ props.item.last_name }}</td>
                  <td>
                    {{ props.item.sign_in_date || props.item.sign_out_date }}
                  </td>
                  <td>
                    {{ props.item.sign_in_time || props.item.sign_out_time }}
                  </td>
                  <td>
                    {{
                      props.item.sign_in_time_zone ||
                        props.item.sign_out_time_zone
                    }}
                  </td>
                  <td>
                    <v-btn
                      color="info"
                      small
                      @click="handleMoreInfo(props.item)"
                      >View
                    </v-btn>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import APIAttendance from "@/mixins/APIAttendance";
import Domain from "@/mixins/domain";
// import moment from "moment";
export default {
  mixins: [APIAttendance, Domain],
  data() {
    return {
      search: "",
      complex: {
        selected: [],
        headers: [
          {
            text: "First Name",
            value: "first_name"
          },
          {
            text: "Last Name",
            value: "last_name"
          },
          {
            text: "Date",
            value: "sign_in_date" || "sign_out_date"
          },
          {
            text: "Time",
            value: "sign_in_time" || "sign_out_time"
          },
          {
            text: "Time Zone",
            value: "sign_in_time_zone" || "sign_out_time_zone"
          }
        ],
        items: []
      },
      loginSession: [
        {
          type: "singin",
          val: "in"
        },
        {
          type: "singout",
          val: "out"
        }
      ],
      e1: "singin",
      logType: "in",
      date: null,
      startDateMenu: false,
      startDate: null,
      endDateMenu: false,
      endDate: null
    };
  },
  created() {
    // this.handleGet();
    this.dateFormat();
  },
  methods: {
    dateFormat: function() {
      const moment = require("moment");
      let now = moment();
      let date = now.format();
      let fomatDate = date.split("T");
      let toDate = fomatDate[0];
      this.endDate = toDate;

      let month = moment().weekday(-7);
      let dateEnd = month.format();
      let fomatDateEnd = dateEnd.split("T");
      let end = fomatDateEnd[0];
      this.startDate = end;
      // alert(this.endDate);
      this.handleGet(this.endDate, this.startDate);
    },
    type: function(val) {
      // console.log(val)
      if (val === "singout") {
        this.logType = "out";
      } else {
        this.logType = "in";
      }
      this.handleGet(this.endDate, this.startDate);
    },
    handleGet: async function(end, start) {
      try {
        let holder_type = "user";
        this.complex.items = await this.historicalList(
          holder_type,
          this.logType,
          start,
          end
        );
      } catch (error) {
        this.$toast.error("Cannot get Historical List!", "Error", {
          position: "topCenter"
        });
      }
    },
    closeDialog() {
      this.$parent.isActive = false;
    },
    handleMoreInfo(row) {
      this.$router.push({
        name: "Historical User View",
        params: { object: row, id: row._id }
      });
    }
  }
};
</script>
